import borrowerRoutes from "./borrower";
import commonRoutes from "./common";
import lenderRoutes from "./lender";

export default [
  ...commonRoutes,
  ...borrowerRoutes,
  ...lenderRoutes,
];
